module.exports = __webpack_public_path__ + "img/logo.96d15e2c.png";